import { tr } from '@repo/locale';
import { type TestId } from '@repo/test-id';
import { formatDate, formatDuration } from '@repo/date-time';

interface Props {
  parkingStartAt: Date | undefined;
  parkingEndAt: Date;
  parkDuration: number;
  testId: TestId;
}

export default function TimeContractTimeDisplay({ parkingStartAt, parkingEndAt, parkDuration, testId }: Props) {
  const formattedDuration: string = formatDuration(parkDuration < 0 ? 0 : parkDuration);
  const formattedStart: string | undefined =
    parkingStartAt !== undefined ? formatDate(parkingStartAt, true) : undefined;
  const formattedEnd: string = formatDate(parkingEndAt, true);

  return (
    <div className="bg-tertiary-medium border-stroke-base col flex w-full flex-col gap-2 rounded-xl border p-2.5">
      <div className="flex items-center justify-start gap-2.5">
        <div className="text-fg-brand justify-start text-sm leading-4 font-medium">
          {tr('parking_search:park_duration.parking_time')}
        </div>
      </div>
      <div className="flex flex-col items-start justify-start gap-1.5">
        <div className="inline-flex items-center justify-start gap-2.5">
          <div
            className="text-heading justify-start text-xl leading-6 font-medium"
            data-testid={testId.append('duration')}
          >
            {formattedDuration}
          </div>
        </div>
        {formattedStart !== undefined && (
          <div className="inline-flex items-center justify-start gap-2.5">
            <div className="text-body-subtle justify-start text-sm leading-4 font-medium">
              {tr('parking_search:park_duration.valid_from')}{' '}
              <span className="whitespace-nowrap" data-testid={testId.append('start')}>
                {formattedStart}
              </span>
            </div>
          </div>
        )}
        <div className="inline-flex items-center justify-start gap-2.5">
          <div className="text-body-subtle justify-start text-sm leading-4 font-medium">
            {tr('parking_search:park_duration.valid_until')}{' '}
            <span className="whitespace-nowrap" data-testid={testId.append('end')}>
              {formattedEnd}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
